import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskCardNumber',
  standalone: true 
})
export class MaskCardNumberPipe implements PipeTransform {
  transform(cardNumber: string | null | undefined): string {
    if (!cardNumber) {
      return '--';
    }

    const visibleDigits = 4;
    const length = cardNumber.length;

    if (length <= visibleDigits) {
      return cardNumber; 
    }

    const maskedPart = 'X'.repeat(length - visibleDigits);
    const visiblePart = cardNumber.slice(-visibleDigits);

    return maskedPart + visiblePart;
  }
}
